var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31766_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1201 14.5359H2.88155C1.40156 14.5359 0.767276 12.9238 1.93013 12.1574L17.5494 1.92951C17.8378 1.75987 18.1663 1.67041 18.5008 1.67041C18.8354 1.67041 19.1639 1.75987 19.4523 1.92951L35.0716 12.1574C36.2344 12.9238 35.6001 14.5359 34.1201 14.5359Z",
    fill: "#CDD3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.358 29.0713H2.64369C1.91389 29.0713 1.32227 29.6631 1.32227 30.3928V34.3571C1.32227 35.0868 1.91389 35.6785 2.64369 35.6785H34.358C35.0877 35.6785 35.6794 35.0868 35.6794 34.3571V30.3928C35.6794 29.6631 35.0877 29.0713 34.358 29.0713Z",
    fill: "#CDD3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28784 14.5356V29.0713V14.5356Z",
    fill: "#CDD3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0952 14.5356V29.0713V14.5356Z",
    fill: "#CDD3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9057 14.5356V29.0713V14.5356Z",
    fill: "#CDD3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.716 14.5356V29.0713V14.5356Z",
    fill: "#CDD3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28784 14.5356V29.0713M14.0952 14.5356V29.0713M22.9057 14.5356V29.0713M31.716 14.5356V29.0713M34.1201 14.5359H2.88155C1.40156 14.5359 0.767276 12.9238 1.93013 12.1574L17.5494 1.92951C17.8378 1.75987 18.1663 1.67041 18.5008 1.67041C18.8354 1.67041 19.1639 1.75987 19.4523 1.92951L35.0716 12.1574C36.2344 12.9238 35.6001 14.5359 34.1201 14.5359ZM34.358 29.0713H2.64369C1.91389 29.0713 1.32227 29.6631 1.32227 30.3928V34.3571C1.32227 35.0868 1.91389 35.6785 2.64369 35.6785H34.358C35.0877 35.6785 35.6794 35.0868 35.6794 34.3571V30.3928C35.6794 29.6631 35.0877 29.0713 34.358 29.0713Z",
    stroke: "#1429B8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31766_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.f7f91c95b0f0adaf7fa33317292761e1.svg";
export { ForwardRef as ReactComponent };